const steps = [
  {
    title: "Sunrun agreement",
    testId: "confirm-names-sunrun-agreement-step",
  },
  {
    title: "Net metering agreement",
    testId: "confirm-names-net-metering-step",
  },
  {
    title: "Contact information",
    testId: "confirm-names-contact-info-step",
  },
];

const NAME_MISMATCH_BANNER_MESSAGE =
  "This is an automated check to help make sure your customer's project is approved. Please confirm that the customer signing the agreement is on title. You can change the name of the signing customer if needed.";

const MISSING_UTILITY_BILL_BANNER_TITLE =
  "No bill uploaded, customer may need to re-sign NEM Agreement";

const UTILITY_MISMATCH_BANNER_TITLE =
  "Update the information below to match the name on the customer’s utility bill.";

const NAME_ON_BILL_UNKNOWN = "Name on bill unknown";

const mismatchModalConfigByStep = [
  {
    title: "Agreement signer must be on title",
    body: [
      "The Sunrun Agreement needs to be signed by the customer whose name is on the home's title.",
      "Signing with the name of a customer who is not on title may require the customer to re-sign.",
    ],
    updateButtonText: "Go back & update signer(s)",
    updateSnackbarMessage:
      'You clicked "Go back & update signer(s)" to fix the name mismatch and avoid a customer re-sign. If you believe it\'s safe to proceed, click "Signer(s) match", then "Proceed & risk re-signing"',
    modalTestId: "confirm-names-title-mismatch-modal",
    acknowledgeTestId: "confirm-names-title-mismatch-acknowledge-checkbox",
  },
  {
    title: "NEM signer must be on the utility bill",
    body: [
      "The NEM Agreement needs to be signed by the customer whose name is on the utility bill.",
      "Our system indicates that the name on the utility bill does not match the NEM Agreement signer.",
    ],
    updateButtonText: "Go back & update utility bill contact",
    updateSnackbarMessage:
      'You clicked "Go back & update utility bill contact" to fix the name mismatch and avoid a customer re-sign. If you believe it\'s safe to proceed, click "Utility Bill Contact matches", then "Proceed & risk re-signing"',
    modalTestId: "confirm-names-utility-mismatch-modal",
    acknowledgeTestId: "confirm-names-utility-mismatch-acknowledge-checkbox",
  },
];

export {
  steps,
  NAME_MISMATCH_BANNER_MESSAGE,
  MISSING_UTILITY_BILL_BANNER_TITLE,
  UTILITY_MISMATCH_BANNER_TITLE,
  NAME_ON_BILL_UNKNOWN,
  mismatchModalConfigByStep,
};
